import getEnv from "@/core/utils/env";

export const baseUrl = (): string => {
  if (process.env.NODE_ENV === "development") {
    return "/";
  } else {
    let url = getEnv("VUE_APP_BASE_API");
    url = url.replace(/\/?$/, "/");
    return url;
  }
};
